<app-modal
  *ngIf="mainContent && primaryAction"
  [modalTitle]="'projectDetails.investDoneDialog.title' | translate"
  [mainContentTemplate]="mainContent"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <div>
    @if (isQualified()) {
      <p>
        {{ "projectDetails.investDoneDialog.qualifiedText" | translate }}
      </p>
    } @else {
      <p>
        {{ "projectDetails.investDoneDialog.notQualifiedText1" | translate }}
      </p>
      <p>
        {{ "projectDetails.investDoneDialog.notQualifiedText2" | translate }}
      </p>
      <p>
        {{ "projectDetails.investDoneDialog.notQualifiedText3" | translate }}
      </p>
    }
  </div>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="button"
    (click)="activeModal.close()"
  >
    {{ "general.close" | translate }}
  </button>
</ng-template>
